import { bool, object } from 'yup';

export const MycawInitialTypeformUpdateSchema = object().shape({
  safeguardCheck: bool().required(),
});
